import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/")({
  head: () => ({ meta: [{ title: "My Account | BAZZAR 3D" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/account-index")),
});
